import ObservationCardGridView from "@/components/observations/ObservationCardGridView";
import { useFeatureName } from "@/hooks/useFeatureName";
import type { LayoutContext } from "@/lib/models";
import { featureCreateObservationUrlBuilder } from "@/lib/url-builder";
import { Observation, ObservationService } from "@/services/ObservationService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const FeatureObservationListPage: React.FC = () => {
  const [observations, setActionsList] = useState<Observation[]>([]);
  const params = useParams();
  const { featureName } = useFeatureName(params.featureId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Feature: ${featureName} Observations`);
    }, [featureName, setPageName]);

  useEffect(() => {
    ObservationService
      .getByFeatureId(params.featureId!)
      .then(setActionsList);
  }, [params.featureId]);

  return (
    <div className="container mx-auto p-4">
      <ObservationCardGridView observations={observations} pageTitle={`Feature: ${featureName} Observations`} createObservationUrl={featureCreateObservationUrlBuilder(params.siteId!, params.featureId!)} />
    </div>
  );
};

export default FeatureObservationListPage;
